import { useMemo } from 'react';
import { useAppSelector } from '../../../../../hooks';
import CompanyContact from './CompanyContact';
import { ApplicationType } from '../../../../../types/PartyApplication/partyApplication';

const ContactDetails = () => {
  const { applicationType, pageTexts } = useAppSelector(
    (state) => state.partyApplication
  );

  const texts = useMemo(() => {
    return pageTexts?.companyDetailsSection;
  }, [pageTexts]);

  const applicationTypeWithCompanyContact = useMemo(() => {
    return (
      applicationType ===
        ApplicationType.dismissedDueToRedundancyOrContractExpiry ||
      applicationType === ApplicationType.dismissedDueToIllnessOrInjury
    );
  }, [applicationType]);

  return (
    <>{applicationTypeWithCompanyContact && <CompanyContact texts={texts} />}</>
  );
};

export default ContactDetails;
